import axios from "axios";

const getProjectClones = (query) =>
  axios.get("api/v1/admin/project-clones", { params: query });

const getProjectClone = (id, query) =>
  axios.get(`api/v1/admin/project-clones/${id}`, { params: query });

const compressPageCovers = (query) =>
  axios.post("api/v1/admin/pages/compress-covers", null, { params: query });

const ApiProjectClones = {
  getProjectClones,
  getProjectClone,
  compressPageCovers,
};

export default ApiProjectClones;
